const s = "Czas działania minął. Proszę sprawdzić swoje połączenie internetowe i spróbować ponownie.", o = { 400: "Ten adres e-mail nie jest zarejestrowany w $t(_company). Upewnij się, że jest poprawny lub zarejestruj się poniżej.", 404: "$t(responses.login.400)", 500: "$t(responses.default)" }, e = { 400: "$t(responses.default)", 500: "$t(responses.default)" }, n = { 2033: "Pomyślnie utworzono sesję.", 2064: "Pomyślnie zaktualizowano sesję." }, a = { 200: "Pomyślnie utworzono Twoją pierwszą sesję.", 201: "$t(responses.dashboardSession.200)" }, i = { 2084: "Prośba o dostęp do sesji została już zatwierdzona", 2088: "Już wysłałeś prośbę o dostęp do tej sesji.", email: { 200: "Osoby dodane" }, domain: { 200: "Grupa dodana" } }, r = { 200: "Świetnie! Będziemy Cię na bieżąco informować." }, t = { 404: "$t(responses.default)", 405: "Kod weryfikacyjny jest nieprawidłowy. Proszę sprawdzić ponownie.", 500: "$t(responses.default)" }, p = { 500: "Przepraszamy, coś poszło nie tak. Proszę spróbować ponownie.", avatar: { 400: "Błąd zapisu awatara. Proszę spróbować ponownie." } }, w = {
  default: "Przepraszamy, coś poszło nie tak. Proszę spróbować ponownie.",
  timeout: s,
  login: o,
  register: e,
  session: n,
  dashboardSession: a,
  sessionAccess: i,
  subscribe: r,
  verify: t,
  user: p
};
export {
  a as dashboardSession,
  w as default,
  o as login,
  e as register,
  n as session,
  i as sessionAccess,
  r as subscribe,
  s as timeout,
  p as user,
  t as verify
};
